module.exports = __webpack_public_path__ + "static/media/bot.a25612c0.svg";